import React from 'react';
import { Plus, ArrowLeft } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';
import { useNavigate } from 'react-router-dom';
import { useForumPosts } from '../../hooks/useForumPosts';
import { LoadingScreen } from '../../../../components/ui/loading';

export function ForumPostList() {
  const navigate = useNavigate();
  const { posts, loading, error } = useForumPosts();

  const getUserName = (post) => {
    if (!post.users) return 'Usuario';
    const metadata = post.users.raw_user_meta_data;
    return metadata?.name || metadata?.full_name || post.users.email.split('@')[0];
  };

  if (loading) {
    return <LoadingScreen />;
  }

  if (error) {
    return (
      <div className="container mx-auto py-6 px-4">
        <div className="text-center text-red-500">
          Error al cargar los posts: {error}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="sticky top-0 bg-white dark:bg-gray-800 border-b dark:border-gray-700">
        <div className="flex items-center p-4">
          <button 
            onClick={() => navigate('/')}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
          >
            <ArrowLeft className="w-5 h-5 dark:text-gray-200" />
          </button>
          <h1 className="text-xl font-bold ml-2 dark:text-white">Foro</h1>
          <div className="flex-1" />
          <button
            onClick={() => navigate('/forum/new')}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Plus className="h-5 w-5" />
            <span>Nuevo post</span>
          </button>
        </div>
      </div>

      {/* Posts List */}
      <div className="p-4 space-y-4">
        {posts.length === 0 ? (
          <div className="text-center text-gray-500 dark:text-gray-400 py-8">
            No hay posts todavía. ¡Sé el primero en crear uno!
          </div>
        ) : (
          posts.map(post => (
            <div
              key={post.id}
              onClick={() => navigate(`/forum/post/${post.id}`)}
              className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer"
            >
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                {post.title}
              </h2>
              <p className="mt-2 text-gray-600 dark:text-gray-300">
                {post.content}
              </p>
              <div className="flex items-center gap-2 mt-4 text-sm text-gray-500 dark:text-gray-400">
                <span>{getUserName(post)}</span>
                <span>•</span>
                <span>{formatDistanceToNow(new Date(post.created_at), { locale: es, addSuffix: true })}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
} 